import TRACE_API from "./api_client/trace_api";
import ARPS_API from "./api_client/arps_api";
import { combineReducers } from "redux";
import siteReducer from "./slices/site";
import authReducer from "./slices/auth";

const rootReducer: any = combineReducers({
  site: siteReducer,
  auth: authReducer,
  [TRACE_API.reducerPath]: TRACE_API.reducer,
  [ARPS_API.reducerPath]: ARPS_API.reducer,
});

export default rootReducer;
